import { css } from 'styled-components';

export const NoResultStyles = css`
  .b-grid-subgrid.b-grid-subgrid-locked {
    &:first-child:before {
      display: none;
    }
    .no-result {
      width: 100%;
      padding: var(--layout-05) var(--layout-02);
    }
  }
`;

export const LoaderStyles = css`
  .custom-loader {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.1);
  }
`;
